export default {
  breakpoint_narrow: '512px',
  breakpoint_medium: '768px',
  breakpoint_wide: '1024px'
};
